import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { FC, PropsWithChildren } from 'react';
import { BillingAlertBanner } from './BillingAlertBanner';
import { SuspendedPage } from './SuspendedPage';

const GET_ORG_STATUS = gql`
  query GetOrgStatus {
    getOrganization {
      organizationId
      status
      scheduledDeletion
      billingAlertType
    }
  }
`;

interface OrgStatusData {
  getOrganization: {
    organizationId?: string;
    status: string;
    scheduledDeletion?: string | null;
    billingAlertType?: string | null;
  } | null;
}

export const OrgStatusGuard: FC<PropsWithChildren> = ({ children }) => {
  const { data, loading } = useQuery<OrgStatusData>(GET_ORG_STATUS, { fetchPolicy: 'network-only' });

  // Don't render children until org status is known — prevents flash of app for suspended orgs
  if (loading) {
    return null;
  }

  const org = data?.getOrganization;

  if (org?.status === 'suspended') {
    return <SuspendedPage scheduledDeletion={org.scheduledDeletion} />;
  }

  return (
    <>
      {org?.billingAlertType && (
        <BillingAlertBanner billingAlertType={org.billingAlertType} />
      )}
      {children}
    </>
  );
};
